import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '@appShared/services/common.service';
import { AdminService, ShareholderEditSectionData, ShareholderEditSection_ } from '@appShared/services/admin.service';
import {
   ConfirmModalComponent,
   ConfirmService,
   ConfirmTemplateDirective
} from '@appShared/components/confirm-modal-and-service';
import {
  IPlan,
  IPlanDetail,
  IShareholder
} from '@appShared/interfaces/[Model-based]';
import { ToastrType } from '../../../../shared/services/toastr.service';
import { ShareholderPlanDetailEditModalComponent } from '../shareholder-plan-detail-edit/shareholder-plan-detail-edit-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-shareholder-plan-detail-list',
   templateUrl: './shareholder-plan-detail-list.component.html',
   styleUrls: ['./shareholder-plan-detail-list.component.less'],
   imports: [
      ConfirmTemplateDirective,
      ConfirmModalComponent
   ]
})
export class ShareholderPlanDetailListComponent implements OnInit, OnChanges {
  @Input() shareholder: IShareholder;
  @Input() plan: IPlan;
  @Input() canEdit: boolean;
  @Input() refreshGrid: () => void;
  @Output() shareholderUpdated = new EventEmitter();

  planDetails: IPlanDetail[] = [];
  isLoading: boolean;
  isDeleting: boolean;
  formatNumber: Function;
  formatCurrency: Function;

  constructor(
    private _adminService: AdminService,
    private _commonService: CommonService,
    private _confirmService: ConfirmService,
    private _modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.formatNumber = this._commonService.formatNumber;
    this.formatCurrency = this._commonService.formatCurrency;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['plan']?.currentValue) {
      this._getPlanDetails();
    }
  }

  /*
   * private methods
   * */

  private _getPlanDetails(): void {
    if (this.plan.id) {
      this._adminService
        .getPlanDetails(this.plan)
        .then(planDetails => {
          this.planDetails = planDetails;
        })
        .catch(() => {
          /* Do Nothing */
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.planDetails = [];
    }
  }

  /*
   * public methods
   * */

  showPlanDetail(planDetail?: IPlanDetail): void {
    /* 4/7/22 - no longer limit adding plan detail if they have a repurchaseOptionAsOf date */
    //if (planDetail?.id || (this.shareholder.id && !this.shareholder.repurchaseOptionAsOf)) {

    if (planDetail?.id || this.shareholder.id) {
      planDetail =
        planDetail || ({
          id: 0,
          planId: this.plan.id
        } as IPlanDetail);
      const shareholderPlanDetailEditModalRef = this._modalService.open(
        ShareholderPlanDetailEditModalComponent,
        { scrollable: true, windowClass: 'my-modal-md' }
      );
      const shareholderPlanDetailsComponent =
        shareholderPlanDetailEditModalRef.componentInstance;
      shareholderPlanDetailsComponent.shareholder = { ...this.shareholder };
      shareholderPlanDetailsComponent.planDetail = { ...planDetail, plan: { ...this.plan } };
      shareholderPlanDetailsComponent.canEdit = this.canEdit;
      shareholderPlanDetailsComponent.refreshGrid = () => {

        this.shareholderSectionUpdated({
          shareholderEditSection: ShareholderEditSection_.basicInfo,
          shareholder: this.shareholder,
          refresh: true
        } as ShareholderEditSectionData);
      };
    } else if (!this.shareholder.id) {
      this._commonService.messageUser(
        `You somehow got to this page without choosing
          a plan. Unable to Add Plan Detail`,
        'Error Occurred!',
        ToastrType.error
      );
    } else {
      this._commonService.messageUser(
        `${this.shareholder.info.displayName} has
        a repurchase option term commencement date.<p>Correct this issue before proceeding.</p>`,
        'Repurchase Option!',
        ToastrType.error
      );
    }
  }

  deletePlanDetail(planDetail: IPlanDetail): void {
    this._confirmService
      .confirm({
        title: 'Deleting Stock Plan Detail!',
        message: `You are deleting the ${planDetail.year} stock plan detail<br/><br/>
            Are you sure?`
      })
      .then(() => {
        this.isDeleting = true;

        /* attach plan to object needed for delete logic*/
        planDetail = { ...planDetail, plan: { ...this.plan } };

        this._adminService
          .deletePlanDetail(planDetail)
          .then(() => {
            this._commonService.messageUser('Stock Plan deleted!');

            this.shareholderSectionUpdated({
              shareholderEditSection: ShareholderEditSection_.planInfo,
              shareholder: this.shareholder,
              refresh: true
            } as ShareholderEditSectionData);
          })
          .catch(() => {
            /* Do Nothing */
          })
          .finally(() => setTimeout(() => (this.isDeleting = false), 500));
      })
      .catch(() => {
        /* Do Nothing */
      });
  }

  shareholderSectionUpdated(shareholderEditSectionData: ShareholderEditSectionData): void {
    this._getPlanDetails();
    this.shareholderUpdated.emit(shareholderEditSectionData);
  }
}
